<template>
  <div>
    <router-link :to="{ name: 'enterprise-rg-object-history-player' }">
      <div
        class="menu-icon-button"
        :class="{ 'mobile-menu-icon-button': this.isMobileDevice }"
      >
        <vx-tooltip
          :text="tooltipSettings.text"
          :position="tooltipSettings.position"
        >
          <div class="menu-icon cursor-pointer"></div>
        </vx-tooltip>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "RgHistoryMenuButton",
  props: {
    isMobileDevice: {
      type: Boolean,
      default: false,
    },
    tooltipSettings: {
      type: Object,
      default() {
        return {
          text: "",
          position: "right",
        };
      },
    },
    handleClick: {
      type: Function,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_mixin.scss";
@import "@/assets/scss/aisea/_variables.scss";

.menu-icon-button {
  position: absolute;
  top: 78px;
  left: 20px;
  z-index: 3;

  &.mobile-menu-icon-button {
    @media screen and (max-width: $min-width-iphone-8) {
      left: 66px;
    }

    @media screen and (min-width: ($min-width-iphone-8 + 1)) and (max-width: $max-width-ipad-pro-12) {
      left: 70px;
    }
    .menu-icon {
      height: 40px;
      width: 40px;
      border-radius: 5px;
    }
  }

  .menu-icon {
    @include image-button("md");
    background: url("~@/assets/images/icons/lolcal/rg_object_history_menu_default.svg")
      no-repeat;
    background-size: contain;

    &:hover {
      background: url("~@/assets/images/icons/lolcal/rg_object_history_menu_hover.svg")
        no-repeat;
      background-size: contain;
    }

    &:active {
      background: url("~@/assets/images/icons/lolcal/rg_object_history_menu_press.svg")
        no-repeat;
      background-size: contain;
    }
  }
}
</style>
